import { useMemo } from "react";

import { useLocation } from "@/utils/location-provider";

export { DEFAULT_CATEGORY_SLUG } from "../../config/category-template-order";

export const parseCategorySlug = (pathname: string) => {
    let slug = null;
    const [segment, prefix] = pathname.split("/").reverse();
    if (prefix === "categories") {
        slug = segment ?? slug;
    }
    return slug;
};

export const useCategorySlug = () => {
    const { pathname } = useLocation();
    return useMemo(() => parseCategorySlug(pathname), [pathname]);
};
